export const areObjectsEqual = (obj1, obj2) => {
  const sortedObj1 = JSON.parse(JSON.stringify(obj1, Object.keys(obj1).sort()))
  const sortedObj2 = JSON.parse(JSON.stringify(obj2, Object.keys(obj2).sort()))

  return JSON.stringify(sortedObj1) === JSON.stringify(sortedObj2)
}
